var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.81,
    y: 123.52,
    width: 123.46,
    height: 82.54,
    transform: "translate(537.33 -207.75) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.3,
    y: 123.52,
    width: 123.46,
    height: 82.54,
    transform: "translate(534.82 -205.25) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.37,
    y: 113.66,
    width: 61.32,
    height: 102.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.94,
    y: 164.09,
    width: 102.25,
    height: 1.39,
    transform: "translate(504.86 -175.28) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.82,
    y: 269.51,
    width: 35,
    height: 112.89,
    transform: "translate(464.65 651.91) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.47 382.4 214.82 382.4 214.82 366.38 228.44 366.38 221.47 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.85,
    y: 269.51,
    width: 35,
    height: 112.89,
    transform: "translate(838.71 651.89) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.82,
    y: 269.51,
    width: 192.83,
    height: 110.54,
    transform: "matrix(-1, 0, 0, -1, 622.48, 649.56)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.84,
    y: 230.37,
    width: 25.41,
    height: 117.14,
    transform: "translate(-10.39 567.5) rotate(-90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.33,
    y: 258.48,
    width: 25.41,
    height: 60.92,
    transform: "translate(83.11 660.98) rotate(-90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,279.31h12.05a27.09,27.09,0,0,0,13.84-3.46H352.17A27.09,27.09,0,0,0,366,279.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.79,279.31h68.27a27.09,27.09,0,0,0,13.84-3.46H230A27.11,27.11,0,0,0,243.79,279.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.84,
    y: 263.06,
    width: 25.41,
    height: 117.14,
    transform: "translate(-43.07 600.18) rotate(-90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.33,
    y: 291.17,
    width: 25.41,
    height: 60.92,
    transform: "translate(50.42 693.67) rotate(-90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,312h12.05a27.18,27.18,0,0,0,13.84-3.45H352.17A27.18,27.18,0,0,0,366,312Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.79,312h68.27a27.09,27.09,0,0,0,13.84-3.46H230A27.11,27.11,0,0,0,243.79,312Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.84,
    y: 295.74,
    width: 25.41,
    height: 117.14,
    transform: "translate(-75.76 632.87) rotate(-90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.33,
    y: 323.85,
    width: 25.41,
    height: 60.92,
    transform: "translate(17.74 726.36) rotate(-90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,344.68h12.05a27.09,27.09,0,0,0,13.84-3.46H352.17A27.11,27.11,0,0,0,366,344.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.8,344.68h68.26a27.15,27.15,0,0,0,13.85-3.46H230A27.09,27.09,0,0,0,243.8,344.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.01 382.4 407.65 382.4 407.65 366.38 394.04 366.38 401.01 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.23,249.42s-1,11.47-40,11.47-39.94-11.47-39.94-11.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.23,258s-1,11.47-40,11.47S339.34,258,339.34,258Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.59 382.4 186.61 382.4 174.75 279.47 146.59 279.47 146.59 382.4",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.05 382.4 168.05 382.4 177.44 261.93 88.44 261.93 79.05 382.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.64 382.4 165.26 382.4 174.65 261.93 82.04 261.93 72.64 382.4",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.51 372.9 164.42 271.42 90.79 271.42 82.88 372.9 156.51 372.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.23,
    y: 75.69,
    width: 226.79,
    height: 165.29,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.99,
    y: 84.43,
    width: 211.27,
    height: 147.8,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.45 232.24 93.28 232.24 114.16 84.43 136.33 84.43 115.45 232.24",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.24 232.24 148.06 232.24 168.94 84.43 191.12 84.43 170.24 232.24",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.87 232.24 229.78 232.24 250.66 84.43 261.75 84.43 240.87 232.24",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.74 232.24 178.65 232.24 199.53 84.43 210.62 84.43 189.74 232.24",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.36,
    y: 84.43,
    width: 10.45,
    height: 147.8,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.81,
    y: 84.43,
    width: 2.33,
    height: 147.8,
    transform: "translate(283.95 316.67) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.02,
    y: 75.69,
    width: 1.67,
    height: 165.29,
    transform: "translate(579.71 316.67) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "296.58 387.31 309.26 379.99 317 395.48 306.41 401.62 296.58 387.31",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.59 387.31 309.27 379.99 313.6 388.67 302.09 395.33 296.59 387.31",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.14,337.35c9-20.8,23.77-45,17.71-67.28l-40.36-6.38s-8.34,49.86-6.69,70.31c1.72,21.26,26.82,59,26.82,59l14.45-8.48S306.79,352.26,301.14,337.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301.14,337.35c9-20.8,23.77-45,17.71-67.28l-40.36-6.38s-8.34,49.86-6.69,70.31c1.72,21.26,26.82,59,26.82,59l14.45-8.48S306.79,352.26,301.14,337.35Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "314.53 384.35 298.02 394.1 292.76 387.27 312.22 376.96 314.53 384.35",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.09,330.78c4.86-10.53,10.46-21.75,13.63-33C308.19,299.38,300.11,307.12,304.09,330.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.58,391.81a.6.6,0,0,0-1,.05c-2.08,3.57-8.07,7-10.39,8.22a2.38,2.38,0,0,0-1.13,1.37c-1.13,3.48-5.6,8.68-5.6,8.68a11,11,0,0,0,.81,2.32,1.7,1.7,0,0,0,2.59.59l18.41-15a1.42,1.42,0,0,0,.1-2.13A41.22,41.22,0,0,1,316.58,391.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.39 394.37 335.02 394.51 333.69 411.79 321.46 411.69 320.39 394.37",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,409.13a.54.54,0,0,0-.73-.57c-4,1.46-10.71.35-13.24-.16a2.45,2.45,0,0,0-1.77.35c-3.24,2-9,3.2-9,3.2a12.58,12.58,0,0,0-1,2.19,1.69,1.69,0,0,0,1.6,2.22l22.56,0a1.43,1.43,0,0,0,1.43-1.48A40.62,40.62,0,0,1,335,409.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.39 394.38 335.03 394.51 334.28 404.19 320.99 404.07 320.39 394.38",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.29,336.16c4.56-21.73,12.77-50,7-61.2L304,267.64s5.87,45,7.42,65.91c1.61,21.77,8,66.76,8,66.76l15.83,0S346.3,362.08,344.29,336.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.29,336.16c4.56-21.73,12.77-50,7-61.2L304,267.64s5.87,45,7.42,65.91c1.61,21.77,8,66.76,8,66.76l15.83,0S346.3,362.08,344.29,336.16Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337 400.95 317.95 400.95 317.65 393.01 338.64 393.35 337 400.95",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.5,199l-1.2,1-1.12.88c-.75.57-1.5,1.11-2.26,1.66-1.5,1.09-3.05,2.1-4.6,3.12a107.91,107.91,0,0,1-9.75,5.56,80.26,80.26,0,0,1-10.7,4.52,52.18,52.18,0,0,1-12.25,2.72l-.81.08a8.19,8.19,0,0,1-5.79-1.66,22.69,22.69,0,0,1-6.68-8.5,26.25,26.25,0,0,1-1.6-4.26,36.25,36.25,0,0,1-1-4.11q-.31-2-.48-4c-.09-1.31-.11-2.61-.11-3.9s.1-2.56.21-3.82l.23-1.91.33-2a5.2,5.2,0,0,1,9.91-1.2l.42,1c.15.37.33.94.51,1.42l.52,1.49c.34,1,.72,2,1.09,3a51.71,51.71,0,0,0,2.39,5.44,21.28,21.28,0,0,0,2.69,4.21,4.86,4.86,0,0,0,2.23,1.71l-6.6-1.59a43.22,43.22,0,0,0,7.66-2.65c1.33-.58,2.67-1.25,4-1.95s2.7-1.42,4-2.2c2.68-1.56,5.38-3.22,8-5,1.33-.87,2.64-1.78,3.95-2.67l1.94-1.37,1.79-1.27.41-.29A10.41,10.41,0,0,1,316.5,199Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.85,183.94l-5.17,3.37c-6.33,1.39-6.71-7.06-6.71-7.06l-1.82-4a3.27,3.27,0,0,1,1.41-4l3.59-2.38a3.41,3.41,0,0,1,4.72.59l2.14,3.18a6.83,6.83,0,0,1,1.12,3.09Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.16,178c-9.9-.59-30.25,12.18-30.25,12.18-2.34,7.46,1.74,21.6,7.71,25.1,0,0,15.15-6.51,22.27-12.84C324.51,194.81,336.19,179.2,316.16,178Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.08,178a185.35,185.35,0,0,1,40.13,6.87c7.55,2.28,12.25,7.93,8.87,23.59-6.86,31.77-6.3,57.72-12.17,68.62,0,0-68.68,4.24-77.87-11.6,1.86-39.23,20.66-69.12,29-81.48A13.7,13.7,0,0,1,317.08,178Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,182.37c1.77-1.27,3.24-.15,4.34-2.3a7.92,7.92,0,0,0,0-5.35l19.84-7.05c-1.4,6.68-2.5,12,.07,15.1.09,5.15-11.82,9.86-21.88,7.95C314.44,189,318.42,184.2,321,182.37Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.45,175.33l15-1.38c-4.54,5.18-11.61,7.31-14.93,5.37A8,8,0,0,0,325.45,175.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,156.53c-.79-7.69,6.7-17.42,13-14.06S324,156.53,324,156.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.41,160.92c-4,8.75-6.86,14.62-13.51,16.42-13.2,3.59-17.55-3.66-16.28-13.46,1.15-8.81,7.45-21.66,17.58-21.8A13.26,13.26,0,0,1,350.41,160.92Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.12,167.93c-4.53-.65-7.85-8.83-3.11-13.11s3.11-8.38-.33-9.6-9.69-.34-11.12-3.4,8.1-5.28,13.63-1.76,5.25,1.39,5.25,1.39a1.33,1.33,0,0,1-1,2.18c4.35,2.89,9.17,9.85,4.68,12.7C361.74,159.52,353,167.08,348.12,167.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.69,155.85a3.48,3.48,0,0,0,4.3-1.3S359.94,158.27,354.69,155.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.49,165.13a7.8,7.8,0,0,0,1.23-.66.23.23,0,0,0,0-.33.28.28,0,0,0-.36-.07,7,7,0,0,1-6,.85.23.23,0,1,0-.17.43A7.3,7.3,0,0,0,332.49,165.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.82,158.23a4.35,4.35,0,0,1,3.26.61A8.63,8.63,0,0,1,337.82,158.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,159a3.56,3.56,0,0,1,2.72,1.27A7.09,7.09,0,0,1,337.73,159Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.85,170.4a9,9,0,0,1-6.57,2.29c-3.2-.22-2.78-2.74-1-5.2,1.58-2.23,4.17-5.4,7-4S352,168.41,349.85,170.4Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,158c-.28.73-.9,1.17-1.37,1s-.64-.93-.36-1.66.89-1.17,1.37-1S336.24,157.22,336,158Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.51,154.66c-.27.73-.89,1.17-1.36,1s-.64-.93-.36-1.66.89-1.17,1.36-1S327.79,153.93,327.51,154.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.15,155.85l-2.13,6.4a4.15,4.15,0,0,1-4.24-1.41C325.9,157.55,330.15,155.85,330.15,155.85Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.85,153.69a.36.36,0,0,0,.23,0,.46.46,0,0,0,.36-.54,4.61,4.61,0,0,0-2.52-3.37.45.45,0,0,0-.6.25.47.47,0,0,0,.25.6h0a3.67,3.67,0,0,1,2,2.69A.46.46,0,0,0,339.85,153.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.34,151.24a.44.44,0,0,0,.42-.1,3.62,3.62,0,0,1,3.18-.92.45.45,0,0,0,.56-.32.46.46,0,0,0-.32-.57,4.56,4.56,0,0,0-4,1.12.46.46,0,0,0,0,.65A.44.44,0,0,0,324.34,151.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.44,209l-4.34,11.85a6,6,0,0,1-4.71,3.95l-57.67,8.73c-3.72.57-5.92,4.39-4.91,8.53L167,325.2c1,4.15,4.84,7.05,8.56,6.49L312.83,310.9c3.72-.57,5.92-4.38,4.92-8.53L293.42,202.18c-1-4.15-4.84-7.05-8.56-6.49L223.15,205A6,6,0,0,0,218.44,209Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.44,209l-4.34,11.85a6,6,0,0,1-4.71,3.95l-57.67,8.73c-3.72.57-5.92,4.39-4.91,8.53L167,325.2c1,4.15,4.84,7.05,8.56,6.49L312.83,310.9c3.72-.57,5.92-4.38,4.92-8.53L293.42,202.18c-1-4.15-4.84-7.05-8.56-6.49L223.15,205A6,6,0,0,0,218.44,209Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.85,87.41a38.65,38.65,0,0,1,4.05.22A48.67,48.67,0,0,1,277.7,98.4,33.45,33.45,0,0,1,272,164.82H188.85a38.71,38.71,0,0,1,0-77.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.44 151.28 192.44 247.78 263.2 247.78 263.2 172.29 242.2 151.28 192.44 151.28",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.44 151.28 192.44 247.78 263.2 247.78 263.2 172.29 242.2 151.28 192.44 151.28",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.2 172.29 242.2 151.28 263.2 172.29 242.2 172.29",
    style: {
      fill: "#407BFF",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.75,
    y: 331.71,
    width: 5.07,
    height: 1.01,
    transform: "translate(-47.46 32.44) rotate(-8.59)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.31,
    y: 329.15,
    width: 17.71,
    height: 1.01,
    transform: "translate(-46.91 34.96) rotate(-8.59)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.68,218.47l-6.53,10.89A7.7,7.7,0,0,1,231.8,233l-57.66,8.74a7.77,7.77,0,0,0-6.44,7.86l3.35,75.84a6,6,0,0,0,7,5.83l137.27-20.8a7.77,7.77,0,0,0,6.44-7.86l-4-91.38a6,6,0,0,0-7-5.83L249,214.79A7.66,7.66,0,0,0,243.68,218.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.69,137.29a1.24,1.24,0,0,1-.88-2.12,24,24,0,1,0-34,0,1.24,1.24,0,0,1,0,1.76,1.26,1.26,0,0,1-1.76,0,26.51,26.51,0,1,1,37.49,0A1.24,1.24,0,0,1,245.69,137.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.45,144.72V117.05a4.51,4.51,0,0,0-4.51-4.51H221.7a4.51,4.51,0,0,0-4.51,4.51v27.67h-4.61l15.24,13.13,15.23-13.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.8,213.47l-.61,1.37-.57,1.25c-.39.83-.8,1.63-1.2,2.44-.81,1.61-1.69,3.17-2.57,4.74A106.42,106.42,0,0,1,351,232.4c-1.08,1.48-2.18,3-3.36,4.41s-2.43,2.86-3.75,4.26a55.51,55.51,0,0,1-9.09,7.88l-.69.47a5.8,5.8,0,0,1-1.13.59A33.85,33.85,0,0,1,322,252.07a63.58,63.58,0,0,1-9.45-.37,88.82,88.82,0,0,1-8.9-1.5,78.15,78.15,0,0,1-8.64-2.43,5.26,5.26,0,0,1,1.29-10.2l.21,0,8.11-.69c2.7-.24,5.36-.5,7.94-.85,1.29-.17,2.56-.34,3.79-.55s2.43-.47,3.57-.72a19.42,19.42,0,0,0,5.37-1.92l-1.81,1.06a47.26,47.26,0,0,0,5.38-5.89c.88-1.11,1.73-2.29,2.56-3.5s1.67-2.45,2.48-3.71c1.59-2.55,3.17-5.18,4.65-7.87.76-1.34,1.47-2.71,2.2-4.06l2-3.92.24-.47a10.42,10.42,0,0,1,18.78,9Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,195.79c4.81,17.28-7.4,34.46-7.4,34.46-6.47,1.85-23.52-4.79-27.14-11.15,0,0,5.95-16.34,13-25C350,186,362.17,185.66,365,195.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.31,238l1,6.1c-1.34,6.34-9.2,3.22-9.2,3.22l-4.38,0a3.27,3.27,0,0,1-3.06-2.92l-.7-4.26a3.41,3.41,0,0,1,2.48-4.06l3.77-.64a6.75,6.75,0,0,1,3.28.25Z",
    style: {
      fill: "#ffc3bd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.561ca1efabeb0eee0d28fa3cad3620d3.svg";
export { ForwardRef as ReactComponent };